// The deck in hand: built by the Start button, played by /learn/deck. Memory only: everything a card
// did is already saved (docs/areas/learn.md), so a reload loses nothing but the place in the deck.
import { create } from 'zustand'
import type { Deck, DeckCard } from '@/lib/learnDeck'

interface DeckState {
  deck: Deck | null
  sessionId: string | null
  minutes: number
  play(deck: Deck, sessionId: string, minutes: number): void
  /** Endless: more questions on the end of the deck */
  extend(cards: DeckCard[]): void
  clear(): void
}

export const useDeck = create<DeckState>((set) => ({
  deck: null,
  sessionId: null,
  minutes: 3,
  play: (deck, sessionId, minutes) => set({ deck, sessionId, minutes }),
  extend: (cards) => set((s) => (s.deck ? { deck: { ...s.deck, cards: [...s.deck.cards, ...cards] } } : s)),
  clear: () => set({ deck: null, sessionId: null }),
}))
